import type { ImgHTMLAttributes, ReactElement } from "react";

/** Google — the official Gemini spark (brand gradient) on a light tile.
 *  Google's CURRENT Gemini sparkle (the 2025 "aurora" mark), served verbatim
 *  from public/brand — the official multi-gradient file, never redrawn. */
export function GeminiLogo(
  props: ImgHTMLAttributes<HTMLImageElement>
): ReactElement {
  // eslint-disable-next-line @next/next/no-img-element
  return (
    <img
      src="/brand/gemini-sparkle.svg"
      width={16}
      height={16}
      alt=""
      aria-hidden
      {...props}
    />
  );
}
